import styled, { css } from 'styled-components';

export const TimelineContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 20px;

  @media (max-width: 768px) {
    margin: unset;

    max-height: 220px;
    overflow: auto;

    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #ccc;
      border-radius: 4px;
    }

    &::-webkit-scrollbar-track {
      background-color: transparent;
    }

    &::-webkit-scrollbar-thumb:hover {
      background-color: #aaa;
    }

    &::-webkit-scrollbar-thumb:active {
      background-color: #999;
    }

    &::-webkit-scrollbar-corner {
      background-color: transparent;
    }
  }

  @media (max-height: 770px) {
    margin: 12px 20px;

    max-height: 250px;
    overflow: auto;

    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #ccc;
      border-radius: 4px;
    }

    &::-webkit-scrollbar-track {
      background-color: transparent;
    }

    &::-webkit-scrollbar-thumb:hover {
      background-color: #aaa;
    }

    &::-webkit-scrollbar-thumb:active {
      background-color: #999;
    }

    &::-webkit-scrollbar-corner {
      background-color: transparent;
    }
  }

  @media (max-height: 740px) {
    margin: 12px 20px;

    max-height: 220px;
    overflow: auto;

    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #ccc;
      border-radius: 4px;
    }

    &::-webkit-scrollbar-track {
      background-color: transparent;
    }

    &::-webkit-scrollbar-thumb:hover {
      background-color: #aaa;
    }

    &::-webkit-scrollbar-thumb:active {
      background-color: #999;
    }

    &::-webkit-scrollbar-corner {
      background-color: transparent;
    }
  }

  @media (max-width: 768px) {
    margin: unset;
  }

  @media (max-height: 640px) {
    margin: 8px 20px;

    max-height: 168px;
    overflow: auto;

    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #ccc;
      border-radius: 4px;
    }

    &::-webkit-scrollbar-track {
      background-color: transparent;
    }

    &::-webkit-scrollbar-thumb:hover {
      background-color: #aaa;
    }

    &::-webkit-scrollbar-thumb:active {
      background-color: #999;
    }

    &::-webkit-scrollbar-corner {
      background-color: transparent;
    }
  }

  @media (max-height: 640px) {
    margin: 8px 20px;

    max-height: 168px;
    overflow: auto;

    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #ccc;
      border-radius: 4px;
    }

    &::-webkit-scrollbar-track {
      background-color: transparent;
    }

    &::-webkit-scrollbar-thumb:hover {
      background-color: #aaa;
    }

    &::-webkit-scrollbar-thumb:active {
      background-color: #999;
    }

    &::-webkit-scrollbar-corner {
      background-color: transparent;
    }
  }
`;

interface TimelineItemProps {
  isLast: boolean;
}

export const TimelineItem = styled.div<TimelineItemProps>`
  display: flex;
  align-items: flex-start;
  margin-bottom: 20px;
  position: relative;

  @media (max-height: 740px) {
    margin-bottom: 14px;
  }

  &:before {
    content: '';
    width: 2px;
    height: calc(100% - 2px);
    background-color: ${(props) => (props.isLast ? 'transparent' : '#ccc')};
    position: absolute;
    left: 12px;
    top: 22px;
  }
`;

interface CircleProps {
  status: 'concluído' | 'atendido' | 'pendente' | 'error' | string;
}

export const Circle = styled.div<CircleProps>`
  width: 24px;
  height: 24px;
  min-width: 24px;
  min-height: 24px;
  border-radius: 50%;
  background-color: ${({ status }) => {
    switch (status) {
      case 'concluído':
        return '#0B29FB';
      case 'atendido':
        return '#1BA23F';
      case 'error':
        return '#FC0D1B';
      default:
        return '#495AFF1A';
    }
  }};

  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  z-index: 1;

  ${({ status }) =>
    status === 'pendente' &&
    css`
      border: 1px solid #0b29fb;
    `}
`;

export const TextContainer = styled.div`
  margin-left: 40px;
`;

type LabelProps = {
  isError: boolean;
};

export const Label = styled.div`
  font-size: 14px;
  font-weight: bold;
  color: ${(props: LabelProps) => (props.isError ? '#FC0D1B' : '#666')};
`;

export const Date = styled.div`
  font-size: 12px;
  color: #666;
`;

export const Img = styled.img``;

export const StatusErrorMessage = styled.div`
  font-family: 'Mangueira', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #3d3d3d;
  margin: 8px 0;
`;
